import { Divider } from '@mui/material'
import React from 'react'
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    container: {
        display: "flex"
    },
    headerClass: {
        display: "flex",
        justifyContent: "center",
        height: 45,
        backgroundColor: "black",
        width: "90.7px",
        //width:"107px"
    },
    header: {
        color: 'white',
        paddingTop: "10px",
        fontWeight:"bold",
    },

});
export const TechnicianHeaderComponent = (props: any) => {
    const { header, index, ...other } = props;
    const classes = useStyles();

    return (
        <div className={`${classes.container}`} key={index}>
            <div className={classes.headerClass} >
                <span className={classes.header}>
                    {header}
                    
                </span>

            </div>

            <Divider flexItem sx={{ borderRightWidth: 1, borderColor: 'white', height: 45 }} />

        </div>
    )
}
